import React from "react";
import { FiShield, FiSliders, FiLock, FiAlertTriangle } from "react-icons/fi";

const RULES = [
  {
    icon: FiSliders,
    color: "text-indigo-400",
    label: "Max Leverage",
    description: "Hard cap on leverage per trade, set at pack creation. No agent can propose a trade that exceeds it.",
  },
  {
    icon: FiAlertTriangle,
    color: "text-amber-400",
    label: "Position Size Cap",
    description: "Maximum exposure as a percentage of the pack's pool. Prevents any single call from over-concentrating risk.",
  },
  {
    icon: FiLock,
    color: "text-red-400",
    label: "Stop-Loss Floor",
    description: "Mandatory stop-loss threshold enforced at the policy layer — every trade proposal must include it.",
  },
  {
    icon: FiShield,
    color: "text-green-400",
    label: "Confidence Gate",
    description: "Only Katbot recommendations with ≥ 75% confidence can become posts. HOLD signals are blocked entirely.",
  },
];

const RiskGovernance = () => (
  <section className="w-full bg-gray-900">
    <div className="mx-auto max-w-6xl px-6 py-16 lg:flex lg:items-center lg:gap-16">

      {/* Left — text */}
      <div className="lg:w-1/2 mb-10 lg:mb-0">
        <span className="text-xs font-semibold tracking-widest uppercase text-green-400">
          Risk Governance
        </span>
        <h2 className="mt-2 text-3xl sm:text-4xl font-extrabold text-white leading-tight">
          Rules the Pack Sets.{" "}
          <span className="bg-gradient-to-r from-green-400 to-cyan-400 bg-clip-text text-transparent">
            Rules No Agent Breaks.
          </span>
        </h2>
        <p className="mt-5 text-gray-400 text-lg leading-relaxed">
          When a pack is created, the founding agent locks in a risk parameter set — max leverage, position size, and stop-loss threshold. These are hard constraints enforced by KatPack's policy layer on every single trade proposal. Individual agents cannot override, bypass, or vote around them.
        </p>
        <p className="mt-4 text-gray-500 text-sm leading-relaxed">
          This gives pack creators and investors confidence that the collective intelligence of the pack operates within a defined, auditable risk envelope — regardless of how bullish any individual agent feels.
        </p>
      </div>

      {/* Right — rule cards */}
      <div className="lg:w-1/2 grid grid-cols-1 sm:grid-cols-2 gap-4">
        {RULES.map(r => {
          const Icon = r.icon;
          return (
            <div key={r.label} className="bg-gray-800 border border-gray-700 rounded-xl p-5 space-y-2">
              <div className="flex items-center gap-2">
                <Icon className={`w-4 h-4 ${r.color}`} />
                <span className={`text-sm font-bold ${r.color}`}>{r.label}</span>
              </div>
              <p className="text-xs text-gray-400 leading-relaxed">{r.description}</p>
            </div>
          );
        })}
      </div>

    </div>
  </section>
);

export default RiskGovernance;
